import axios from "@/http"

export function listSchoolNotices(param){
  return axios({
    method:"GET",
    url:"/api/v1/information/poster/schoolnotices",
    params:param
  })
}
export function deleteSchoolNotices(id){
  return axios({
    url: '/api/v1/information/poster/schoolnotices/' + id,
    method: 'delete'
  })
}
export function getSchoolNotice(id) {
  return axios({
    url: '/api/v1/information/poster/schoolnotices/' + id,
    method: 'get',
    params:{ id,preload: true }
  })
}
export function listDepartmentNotices(param){
  return axios({
    method:"GET",
    url:"/api/v1/information/poster/departmentnotices",
    params:param
  })
}
export function updateSchoolNotice(data) {
  return axios({
    url: '/api/v1/information/poster/schoolnotices/' + data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}
export function createSchoolNotices(data){
  return axios({
    method:"POST",
    url:"/api/v1/information/poster/schoolnotices",
    data
  })
}

export function createSchoolPosterAttachment(data){
  return axios({
    url: '/api/v1/information/poster/attachments',
    method: 'POST',
    data
  })
}

export function deleteSchoolAttachment(id) {
  return axios({
    url: '/api/v1/information/poster/attachments/' + id,
    method: 'delete'
  })
}
export function listSchoolComment(query){
  return axios({
    url: '/api/v1/information/poster/schoolnoticecomments',
    method: 'get',
    params: query
  })
}
export function listDepartMentComment(query){
  return axios({
    url: '/api/v1/information/poster/departmentnoticecomments',
    method: 'get',
    params: query
  })
}












export function getDepartmentNotice(id) {
  return axios({
    url: '/api/v1/information/poster/departmentnotices/' + id,
    method: 'get',
    params:{ id,preload: true }
  })
}
export function deleteDepartmentNotices(id){
  return axios({
    url: '/api/v1/information/poster/departmentnotices/' + id,
    method: 'delete'
  })
}
export function updateDepartmentNotice(data) {
  return axios({
    url: '/api/v1/information/poster/departmentnotices/' + data.id,
    method: 'put',
    params: data.where?{where: data.where}: undefined,
    data
  })
}
export function createDepartmentNotices(data){
  return axios({
    method:"POST",
    url:"/api/v1/information/poster/departmentnotices",
    data
  })
}

export function createDepartmentPosterAttachment(data){
  return axios({
    url: '/api/v1/information/poster/attachments',
    method: 'POST',
    data
  })
}

export function deleteDepartmentAttachment(id) {
  return axios({
    url: '/api/v1/information/poster/attachments/' + id,
    method: 'delete'
  })
}




// WEBPACK FOOTER //
// ./src/api/axj-information/axj-information-post.js